<template>
    <el-dialog
            :visible.sync="uplodData.state"
            width="500px"
            :modal="false"
            :close-on-click-modal="false"
            :before-close="closeBtn">
        <p slot="title">
            <span style="visibility: hidden">导入文件</span>
        </p>
        <div style="padding-right: 20px">
            <div>
                <el-form
                        :model="FormData"
                        ref="FormData"
                        label-width="100px"
                        class="demo-ruleForm">
                    <el-form-item label="上传文件">
                        <el-upload
                                style="margin-top: 10px"
                                class="upload-demo"
                                :headers="imHeader"
                                :data="uploadData"
                                :file-list="arrFile"
                                drag
                                action="/hallportal/admin/excel/import"
                                :disabled="hasExistFile"
                                type="drag"
                                :before-upload="handleBeforeUpload"
                                :on-success="handleSuccess"
                                accept=".xls,.xlsx"
                                :format="standardFileState.formatFileType"
                        >
                        <!--<el-upload
                                style="margin-top: 10px"
                                :headers="imHeader"
                                :data="uploadData"
                                :disabled="hasExistFile"
                                drag
                                action="/admin/excel/import"
                                accept=".xls,.xlsx"
                                name="file"
                                :format="standardFileState.formatFileType"
                                :on-success="handleSuccess"
                                :before-upload="handleBeforeUpload"
                        >-->
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或
                                <em v-if="arrFile.length<1">点击上传</em>
                                <span v-else>点击上传</span>
                            </div>
                            <div class="el-upload__tip" slot="tip">可上传.xls,.xlsx,格式文件，且不超过10MB
                            </div>
                            <div style="color: red;" class="el-upload__tip" slot="tip">
                                注意：文件必上传，一次只能上传一个文件
                            </div>
                        </el-upload>
                        <!--<el-progress v-if="upfile.progress.flag" :percentage="upfile.progress.percent"></el-progress>-->
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <span style="color: red">{{proName}}</span>
        </div>
        <div slot="footer" style="text-align: center">
            <el-button @click="closeBtn">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import moment from "moment";
    export default {
        props: {
            uplodData: {
                type: Object,
                required: true
            }
        },
        name: "uplodModal",
        data() {
            return {
                btnState: true,
                FormData: {
                    dimYear: moment(new Date()).format("YYYY")
                },
                proName: "",
                maxUploadFileSize: 10 * 1024 * 1024,
                hasExistFile: false,
                standardFileState: {
                    state: true,
                    formatFileType: ["xls", "xlsx"],
                },
                arrFile: [],
                uploadData:{
                    type:'',
                    dimYear:null,
                    file:null,
                }
            }
        },
        created(){
            let token = window.sessionStorage.getItem('nz_access_token');
            this.imHeader = { 'Authorization': token};
        },
        methods: {
            handleBeforeUpload(file) {
                this.uploadData.dimYear = new Date(this.FormData.dimYear).getFullYear();
                this.uploadData.type = this.uplodData.type;

                if(this.uplodData.type === 'teacher'){
                    this.uploadData['majorId'] = this.uplodData.majorId
                }
                this.hasExistFile = true
                if (file.size > this.maxUploadFileSize) {
                    this.$message.error("上传文件最大不能超过10M，请检查文件上传大小！");
                    return false;
                }
                let extname = file.name.substr(file.name.lastIndexOf(".") + 1, file.name.length - file.name.lastIndexOf("."));
                let foundext = false;
                this.standardFileState.formatFileType.forEach(e => {
                    if (e == extname) {
                        foundext = true;
                    }
                });
                if (!foundext) {
                    this.$message.error("上传的文件类型非指定的文件类型，请选择指定的文件类型");
                    return false;
                }
                this.uploadData.file = file;
            },
            handleSuccess(response, file, fileList) {
                if (response.code == 0) {
                    this.$message({
                        message: "上传成功",
                        type: "success"
                    });
                    this.$emit("successCallBack")
                    this.closeBtn();

                } else {
                    this.proName = '文件上传失败：失败原因：' + response.msg
                }
                this.btnState = false;
            },
            closeBtn() {
                this.proName = "";
                this.hasExistFile = false;
                this.FormData.dimYear = moment(new Date()).format("YYYY")
                this.btnState = true;
                this.arrFile = []
                this.$emit("closeUplod", false)
            },
        }
    }
</script>

<style scoped>
.demo-ruleForm /deep/ .el-upload--text {
    width: 100%;
    height: 150px;
}
</style>
